<script setup lang="ts">
import LayoutWrapper from '@/sites/tfs/layouts/LayoutWrapper.vue';
</script>

<template>
  <LayoutWrapper />
</template>
